import { Route, redirect } from "@tanstack/react-router";
import { rootRoute } from "../root";

export const interventionsXRiskRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/interventions/xrisk",
  beforeLoad: () => {
    throw redirect({ to: "/" });
  },
});
